import Repository from './Repository';
const REPORTS = '/reports';
const UTILS = '/utils';

export default {

  //----------------------------------------------  
  // Make the call to retrieve timing statistics
  getTimingStatistics({ scale, year, month, week, date, weekdays, timeRange, startDate, endDate } = {}) {
    const params = new URLSearchParams();

    // Verify and append parameters if they exist
    if (scale) params.append('scale', scale);
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    if (week) params.append('week', week);
    if (date) params.append('date', date);

    // Custom filter dates
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    // Append each weekday if weekdays is an array
    if (Array.isArray(weekdays)) {
      weekdays.forEach(day => params.append('weekdays[]', day));
    }

    // Append timeRange parameters if timeRange is an object
    if (timeRange && typeof timeRange === 'object') {
      if (timeRange.startHour !== undefined) params.append('timeRange[startHour]', timeRange.startHour);
      if (timeRange.endHour !== undefined) params.append('timeRange[endHour]', timeRange.endHour);
    }

    // Construct the final query string
    const query = params.toString() ? `?${params.toString()}` : '';

    // Make the GET request with the constructed query string
    return Repository.get(`${REPORTS}/avg_timing_report${query}`);
  },

  //----------------------------------------------
  // Make the call to retrieve average statistics
  getSessionsStatistics({ scale, year, month, week, date, weekdays, timeRange, startDate, endDate, compareTo, compareStartDate, compareEndDate } = {}) {
     const params = new URLSearchParams();

    // Verify and append parameters if they exist
    if (scale) params.append('scale', scale);
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    if (week) params.append('week', week);
    if (date) params.append('date', date);

    // Custom filter dates
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);


    // Verify if compareTo exist and is not a custom filter
    if (compareTo && compareTo !== 'custom') {
      params.append('compareTo', compareTo);
    } else if (compareTo && compareTo === 'custom') {

      params.append('compareTo', compareTo);

      params.append('compareStartDate', compareStartDate);
      params.append('compareEndDate', compareEndDate);
    }

    // Append each weekday if weekdays is an array
    if (Array.isArray(weekdays)) {
      weekdays.forEach(day => params.append('weekdays[]', day));
    }

    // Append timeRange parameters if timeRange is an object
    if (timeRange && typeof timeRange === 'object') {
      if (timeRange.startHour !== undefined) params.append('timeRange[startHour]', timeRange.startHour);
      if (timeRange.endHour !== undefined) params.append('timeRange[endHour]', timeRange.endHour);
    }

    // Construct the final query string
    const query = params.toString() ? `?${params.toString()}` : '';

    return Repository.get(`${REPORTS}/sessions/summary${query}`);
  },

    //----------------------------------------------
  // Make the call to retrieve products and categories statistics
  getCoursesStatistics({ scale, year, month, week, date, weekdays, timeRange, startDate, endDate } = {}) {
     const params = new URLSearchParams();

    // Verify and append parameters if they exist
    if (scale) params.append('scale', scale);
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    if (week) params.append('week', week);
    if (date) params.append('date', date);

    // Custom filter dates
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    // Append each weekday if weekdays is an array
    if (Array.isArray(weekdays)) {
      weekdays.forEach(day => params.append('weekdays[]', day));
    }

    // Append timeRange parameters if timeRange is an object
    if (timeRange && typeof timeRange === 'object') {
      if (timeRange.startHour !== undefined) params.append('timeRange[startHour]', timeRange.startHour);
      if (timeRange.endHour !== undefined) params.append('timeRange[endHour]', timeRange.endHour);
    }

    // Construct the final query string
    const query = params.toString() ? `?${params.toString()}` : '';

    return Repository.get(`${REPORTS}/articles/by-courses${query}`);
  },

  //----------------------------------------------
  // Make the call to retrieve products and categories statistics
  getCategoriesStatistics({ scale, year, month, week, date, weekdays, timeRange, startDate, endDate } = {}) {
     const params = new URLSearchParams();

    // Verify and append parameters if they exist
    if (scale) params.append('scale', scale);
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    if (week) params.append('week', week);
    if (date) params.append('date', date);

    // Custom filter dates
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    // Append each weekday if weekdays is an array
    if (Array.isArray(weekdays)) {
      weekdays.forEach(day => params.append('weekdays[]', day));
    }

    // Append timeRange parameters if timeRange is an object
    if (timeRange && typeof timeRange === 'object') {
      if (timeRange.startHour !== undefined) params.append('timeRange[startHour]', timeRange.startHour);
      if (timeRange.endHour !== undefined) params.append('timeRange[endHour]', timeRange.endHour);
    }

    // Construct the final query string
    const query = params.toString() ? `?${params.toString()}` : '';

    return Repository.get(`${REPORTS}/articles/by-categories${query}`);
  },


  //----------------------------------------------
  // Make the call to retrieve list of best articles sold
  getArticlesTop({ scale, year, month, week, date, weekdays, timeRange, startDate, endDate, q } = {}) {
     const params = new URLSearchParams();

    // Verify and append parameters if they exist
    if (scale) params.append('scale', scale);
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    if (week) params.append('week', week);
    if (date) params.append('date', date);
    if (q) params.append('q', q);

    // Custom filter dates
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    // Append each weekday if weekdays is an array
    if (Array.isArray(weekdays)) {
      weekdays.forEach(day => params.append('weekdays[]', day));
    }

    // Append timeRange parameters if timeRange is an object
    if (timeRange && typeof timeRange === 'object') {
      if (timeRange.startHour !== undefined) params.append('timeRange[startHour]', timeRange.startHour);
      if (timeRange.endHour !== undefined) params.append('timeRange[endHour]', timeRange.endHour);
    }

    // Construct the final query string
    const query = params.toString() ? `?${params.toString()}` : '';

    return Repository.get(`${REPORTS}/articles/top${query}`);
  },

  //----------------------------------------------
  // Make the call to retrieve income statistics
  getAvgProfitStatistics({ scale, year, month, week, date, weekdays, timeRange, startDate, endDate, compareTo, compareStartDate, compareEndDate } = {}) {
    const params = new URLSearchParams();

    // Verify and append parameters if they exist
    if (scale) params.append('scale', scale);
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    if (week) params.append('week', week);
    if (date) params.append('date', date);

    // Verify if compareTo exist and is not a custom filter
    if (compareTo && compareTo !== 'custom') {
      params.append('compareTo', compareTo);
    } else if (compareTo && compareTo === 'custom') {

      params.append('compareTo', compareTo);

      params.append('compareStartDate', compareStartDate);
      params.append('compareEndDate', compareEndDate);
    }

    // Custom filter dates
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    // Append each weekday if weekdays is an array
    if (Array.isArray(weekdays)) {
      weekdays.forEach(day => params.append('weekdays[]', day));
    }

    // Append timeRange parameters if timeRange is an object
    if (timeRange && typeof timeRange === 'object') {
      if (timeRange.startHour !== undefined) params.append('timeRange[startHour]', timeRange.startHour);
      if (timeRange.endHour !== undefined) params.append('timeRange[endHour]', timeRange.endHour);
    }

    // Construct the final query string
    const query = params.toString() ? `?${params.toString()}` : '';

    return Repository.get(`${REPORTS}/avg_profit_report${query}`);
  },

  //----------------------------------------------
  // Make call to retrieve profits to show in the chart
  getProfitChart({ scale, year, month, week, date, weekdays, timeRange, startDate, endDate, compareTo, compareStartDate, compareEndDate } = {}) {

    const params = new URLSearchParams();

    // Verify and append parameters if they exist
    if (scale) params.append('scale', scale);
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    if (week) params.append('week', week);
    if (date) params.append('date', date);


    // Verify if compareTo exist and is not a custom filter
    if (compareTo && compareTo !== 'custom') {
      params.append('compareTo', compareTo);
    } else if (compareTo && compareTo === 'custom') {
      params.append('compareTo', compareTo);
      
      params.append('compareStartDate', compareStartDate);
      params.append('compareEndDate', compareEndDate);
    }

    // Custom filter dates
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

        // Append each weekday if weekdays is an array
    if (Array.isArray(weekdays)) {
      weekdays.forEach(day => params.append('weekdays[]', day));
    }

    // Append timeRange parameters if timeRange is an object
    if (timeRange && typeof timeRange === 'object') {
      if (timeRange.startHour !== undefined) params.append('timeRange[startHour]', timeRange.startHour);
      if (timeRange.endHour !== undefined) params.append('timeRange[endHour]', timeRange.endHour);
    }

    // Construct the final query string
    const query = params.toString() ? `?${params.toString()}` : '';

    return Repository.get(`${REPORTS}/profit/chart${query}`);
  },

  //----------------------------------------------
  // Start data syncing process
  startDashboardDataSync() {
    return Repository.post(`${UTILS}/update_live_histories`, {});
  }
};
